import React from "react";
import "../../Css/HomePage/HomeBanner.css";
import { MdOutlineStar } from "react-icons/md";
import { Slide } from "react-awesome-reveal";
import { NavLink } from "react-router-dom";
const HomeBanner = (() => {
    return (
        <>
            <section className="container-fluid home-banner-section">
                <div className="home-section-banner-main-con">
                    <div className="home-section-banner-details-main-con">
                        <Slide direction="up">
                        <div className="home-section-banner-details-con">
                            <h1 className="text-start" style={{color:'white',fontFamily:" var(---Montserrat)"}}>Resort In Neral | Seema Resort</h1>
                            {/* <h2><span>Weekends Made</span> for Relaxation.</h2> */}
                            <div className="home-section-banner-details-con-para">
                                <p className="text-start">
                                    TAKE ADVANTAGE OF THIS AMAZING EXCLUSIVE OFFER
                                    DON'T MISS THIS OPPORTUNITY FOR YOUR BUSINESS
                                </p>
                            </div>
                            {/* <div className="home-banner-section-details-star-main-con">
                                <div className="home-banner-section-details-star-con">
                                    <MdOutlineStar />
                                    <MdOutlineStar />
                                    <MdOutlineStar />
                                    <MdOutlineStar />
                                    <MdOutlineStar />
                                </div>
                            </div> */}
                            {/* <div className="home-section-banner-details-con-btn">
                                <button>
                                    Room E Suites
                                </button>
                            </div> */}
                            <NavLink to='/rooms' style={{textDecoration:"none"}}>
                            <button className="btn btn-lg btn-dark my-2 mb-4 d-flex" style={{
                                backgroundColor:"black",
                                borderRadius:"0"
                            }}>Book Now</button>
                            </NavLink>
                        </div>
                        </Slide>
                    </div>
                </div>
            </section>
        </>
    )
});

export default HomeBanner;